import { RowBetween } from 'layout/Components/Row'
import { useState } from 'react'
import { FlexProps } from 'UIKit/Box/types'
import TransText from 'UIKit/Text/TransText'
import ToogleMode from './ToogleMode'

const ViewModeInMobile: React.FC<{ isUnread: boolean; onValueChanged: (value: boolean) => void } & FlexProps> = ({
  isUnread,
  onValueChanged,
  ...props
}) => {
  const [value, setValue] = useState<boolean>(isUnread)

  const handleValueChanged = (value: boolean) => {
    setValue(value)
    onValueChanged(value)
  }
  return (
    <RowBetween {...props}>
      <TransText fontSize="14px" fontWeight={500} mr="8px" color="text_primary">
        Show Unread
      </TransText>
      <ToogleMode value={value} onValueChanged={handleValueChanged} />
    </RowBetween>
  )
}

export default ViewModeInMobile
